import React, { useState, useEffect, useRef } from 'react';
import { newsAPI, imagaeAPI } from '../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Button } from 'react-bootstrap';
import { STATE, DISTRICTS, CATEGORIES } from '../../components/admin/constants';

import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const NewsForm = ({ onNewsCreated }) => {
    const [formData, setFormData] = useState({
        news_title: '',
        news_content: '',
        categories: "",
        state: STATE,
        district: "",
        video_url: '',
        status: 'active',
        breaking_news: false,
    });
    const [photo, setPhoto] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const photoRef = useRef(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleFileChange = (e) => {
        setPhoto(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const plainText = formData.news_content.replace(/<[^>]*>/g, '').trim();
        if (!plainText) {
            setError('News content is required.');
            toast.error('News content is required.');
            setLoading(false);
            return;
        }

        const data = new FormData();

        // Loop through formData and append values
        Object.keys(formData).forEach(key => {
            if (key === 'breaking_news') {
                // Send 1 for true, 0 for false
                data.append(key, formData[key] ? '1' : '0');
            } else {
                data.append(key, formData[key]);
            }
        });

        if (photo) {
            data.append('photo', photo);
        }

        try {
            const response = await newsAPI.create(data);
            // Reset form...
            setFormData({
                news_title: '',
                news_content: '',
                categories: "",
                state: STATE,
                district: "",
                video_url: '',
                status: 'active',
                breaking_news: false,
            });
            setPhoto(null);
            if (photoRef.current) photoRef.current.value = "";
            if (onNewsCreated) onNewsCreated(response.data.data);
            toast.success('News added successfully!');

        } catch (err) {
            console.error(err);
            const errors = err.response?.data?.errors;
            setError(errors || 'Something went wrong');
            if (errors) toast.error(JSON.stringify(errors));
        } finally {
            setLoading(false);
        }
    };

    return (


        <div className="main-content">
            <div className="content-wrapper">
                {/* Add Form */}
                <div className="form-card">
                    <div className="form-card-header">
                        <h5 className="text-white"><i className="fas fa-plus-circle me-2"></i>Add News</h5>
                        {error && <div className="error">{JSON.stringify(error)}</div>}
                    </div>
                    <div className="form-card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3 mb-3">
                                <div className="form-group col-md-3">
                                    <label>News Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="news_title"
                                        value={formData.news_title}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group col-md-9">
                                    <label>News Content</label>
                                    <ReactQuill
                                        theme="snow"
                                        value={formData.news_content}
                                        onChange={(value) => setFormData(prev => ({ ...prev, news_content: value }))}
                                        style={{ height: '100px', marginBottom: '50px' }}

                                    />
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="form-group col-md-3">
                                    <label>Category</label>
                                    <select name="categories" className="form-control" value={formData.categories} onChange={handleChange} required>
                                        <option value="">Select</option>
                                        {CATEGORIES.map(cat => (
                                            <option key={cat} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-3">
                                    <label>State</label>
                                    <input type="text" className="form-control" name="state" value={STATE} disabled />
                                </div>

                                <div className="form-group col-md-3">
                                    <label>District</label>
                                    <select name="district" className="form-control" value={formData.district} onChange={handleChange} required>
                                        <option value="">Select</option>
                                        {DISTRICTS.map(dist => (
                                            <option key={dist} value={dist}>{dist}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group col-md-3">
                                    <label>Photo</label>
                                    <input type="file" className="form-control" accept="image/*" onChange={handleFileChange} ref={photoRef} />
                                </div>

                                <div className="form-group col-md-3">
                                    <label>Video URL</label>
                                    <input
                                        type="url"
                                        className="form-control"
                                        name="video_url"
                                        value={formData.video_url}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="form-group col-md-3">
                                    <label>Status</label>
                                    <select name="status" className="form-control" value={formData.status} onChange={handleChange}>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>

                                <div className="form-group col-md-3">
                                    <label>
                                        <input
                                            type="checkbox"

                                            name="breaking_news"
                                            checked={formData.breaking_news}
                                            onChange={handleChange}
                                        /> Breaking News
                                    </label>
                                </div>


                            </div>
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? "Wait Please..." : "Add"}
                            </button>
                        </form>
                    </div>
                    <ToastContainer />
                </div>


            </div>
        </div>
    );
};

export default NewsForm;